import { render, staticRenderFns } from "./OrderLimit.vue?vue&type=template&id=14ddec2e&"
import script from "./OrderLimit.vue?vue&type=script&lang=js&"
export * from "./OrderLimit.vue?vue&type=script&lang=js&"
import style0 from "./OrderLimit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports